import { IAddress } from '../address';
import { IContact } from '../contact';
import { ISalesCall } from '../salesCalls';
import { BusinessEntityActionKeys as keys } from './businessEntityActionKeys';
import * as types from './businessEntityActionTypes';
import {
  BusinessListType,
  IBusinessEntityAddress,
  IBusinessEntityMin,
  IBusinessEntityMinDetails
} from './businessEntityInterfaces';

export const businessEntityActionCreators = {
  addAddresses: (
    payload: Array<{ businessEntityId: number; addressIds: number[] }>
  ): types.AddBusinessEntityAddresses => ({
    payload,
    type: keys.ADD_BUSINESS_ENTITY_ADDRESSES
  }),
  addContacts: (contacts: IContact[]): types.AddBusinessEntityContacts => ({
    payload: contacts.map(x => ({ contactId: x.contactId, businessEntityId: x.businessEntityId })),
    type: keys.ADD_BUSINESS_ENTITY_CONTACTS
  }),
  addNames: (payload: Array<{ businessEntityId: number; name: string }>): types.AddBusinessEntityNames => ({
    payload,
    type: keys.ADD_BUSINESS_ENTITY_NAMES
  }),
  addSalesCalls: (salesCalls: ISalesCall[]): types.AddBusinessEntitySalesCalls => ({
    payload: salesCalls.map(x => ({ salesCallId: x.salesCallId, businessEntityId: x.businessEntityId })),
    type: keys.ADD_BUSINESS_ENTITY_SALESCALLS
  }),
  disableLoadingContacts: (payload: number[]): types.DisableLoadingContacts => ({
    payload,
    type: keys.DISABLE_LOADING_CONTACTS
  }),
  disableLoadingSalesCalls: (payload: number[]): types.DisableLoadingSalesCalls => ({
    payload,
    type: keys.DISABLE_LOADING_SALESCALLS
  }),
  fetchMinDetails: (businessEntityId: number) =>
    ({ payload: { businessEntityId }, type: keys.FETCH_BE_MIN_DETAILS } as const),
  removeContact: (item: { contactId: number; businessEntityId: number }): types.RemoveBusinessEntityContact => ({
    payload: item,
    type: keys.REMOVE_BUSINESS_ENTITY_CONTACT
  }),
  removeSalesCall: (item: { salesCallId: number; businessEntityId: number }): types.RemoveBusinessEntitySalesCall => ({
    payload: item,
    type: keys.REMOVE_BUSINESS_ENTITY_SALESCALL
  }),
  saveAddress: (payload: { businessEntityId: number; address: IAddress }): types.SaveAddress => ({
    payload,
    type: keys.SAVE_BUSINESS_ENTITY_ADDRESS
  }),
  saveAddressFulfileed: (payload: { businessEntityId: number; address: IAddress }): types.SaveAddressFulfilled => ({
    payload,
    type: keys.SAVE_BUSINESS_ENTITY_ADDRESS_FULFILLED
  }),
  search: (payload: { type: BusinessListType; zipcode: string }): types.SearchBusinessEntities => ({
    payload,
    type: keys.SEARCH_BUSINESS_ENTITIES
  }),
  setAddresses: (payload: IBusinessEntityAddress[]): types.SetBeAddresses => ({ payload, type: keys.SET_BE_ADDRESSES }),
  setCompetitors: (payload: { beId: number; competitorIds: number[] }) =>
    ({
      payload,
      type: keys.SET_BE_COMPETITORS
    } as const),
  setLoadedContacts: (payload: number[]): types.SetLoadedContacts => ({ payload, type: keys.SET_LOADED_CONTACTS }),
  setLoadedSalesCalls: (payload: number[]): types.SetLoadedSalesCalls => ({
    payload,
    type: keys.SET_LOADED_SALESCALLS
  }),
  setLoadingContacts: (payload: number[]): types.SetLoadingContacts => ({ payload, type: keys.SET_LOADING_CONTACTS }),
  setLoadingSalesCalls: (payload: number[]): types.SetLoadingSalesCalls => ({
    payload,
    type: keys.SET_LOADING_SALESCALLS
  }),
  setMarketSegments: (payload: { beId: number; marketSegmentIds: number[] }) =>
    ({ payload, type: keys.SET_BE_MARKET_SEGMENTS } as const),
  setMinDetails: (payload: IBusinessEntityMinDetails) => ({ payload, type: keys.SET_BE_MIN_DETAILS } as const),
  setProductCategories: (payload: { beId: number; categoryIds: number[] }) =>
    ({ payload, type: keys.SET_BE_PRODUCT_CATEGORIES } as const),
  setRankType: (payload: { beId: number; rankTypeId: number | null }) =>
    ({ payload, type: keys.SET_BE_RANK_TYPE } as const),
  setSalesCallTotal: (payload: { businessEntityId: number; totalItems: number }): types.SetBeSalesCallTotal => ({
    payload,
    type: keys.SET_BE_SALESCALL_TOTAL
  }),
  setSearchResults: (zipcode: string, results: IBusinessEntityMin[]): types.SetBeSearchResults => ({
    payload: { searchTerm: zipcode, results },
    type: keys.SET_BE_SEARCH_RESULTS
  }),
  toggleSearchLoading: (zipcode: string): types.ToggleBeSearchLoading => ({
    payload: zipcode,
    type: keys.TOGGLE_BE_SEARCH_LOADING
  }),
  updateCompetitors: (payload: { beId: number; competitorIds: number[] }) =>
    ({
      payload,
      type: keys.UPDATE_BE_COMPETITORS
    } as const),
  updateMarketSegments: (payload: { beId: number; marketSegmentIds: number[] }) =>
    ({ payload, type: keys.UPDATE_BE_MARKET_SEGMENTS } as const),
  updateProductCategories: (payload: { beId: number; categoryIds: number[] }) =>
    ({ payload, type: keys.UPDATE_BE_PRODUCT_CATEGORIES } as const),
  updateRankType: (payload: { beId: number; rankTypeId: number }) =>
    ({
      payload,
      type: keys.UPDATE_BE_RANK_TYPE
    } as const)
} as const;
